import React from 'react';
import { Link } from 'react-router-dom';
import { Monitor, Printer, Phone, Network, Wrench, Shield, Database, Globe, CheckCircle2, ArrowRight, Info } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Monitor: Monitor,
  Printer: Printer,
  Phone: Phone,
  Network: Network,
  Wrench: Wrench,
  Shield: Shield,
  Database: Database,
  Globe: Globe
};

const PricingSection = () => {
  return (
    <section id="tarifs" data-testid="pricing-section" className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Nos Tarifs
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Une tarification claire et transparente, sans surprise. Retrouvez ci-dessous l'essentiel de nos prix.
          </p>
        </div>

        {/* Pricing Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                data-testid={`pricing-card-${service.slug}`}
                className={`bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300 border-t-4 ${service.borderColor.replace('border-l-', 'border-t-')} flex flex-col`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-11 h-11 ${service.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                    <IconComponent className={`w-6 h-6 ${service.iconColor}`} />
                  </div>
                  <h3 className="font-bold text-gray-900 leading-snug">{service.title}</h3>
                </div>
                <ul className="space-y-2 mb-5 flex-1">
                  {service.priceSummary.map((line, index) => (
                    <li key={index} className="flex items-start gap-2 text-gray-700">
                      <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                      <span className="text-sm">{line}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/services/${service.slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                  className={`inline-flex items-center gap-2 ${service.iconColor} font-semibold text-sm hover:gap-3 transition-all duration-200`}
                >
                  Voir le détail
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            );
          })}
        </div>

        {/* Mentions */}
        <div className="mt-10 bg-blue-50 border border-blue-100 rounded-2xl p-6 flex items-start gap-4" data-testid="pricing-mentions">
          <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <Info className="w-5 h-5 text-blue-500" />
          </div>
          <div className="text-sm text-gray-700 leading-relaxed">
            <p className="font-semibold text-gray-900 mb-1">
              Les tarifs indiqués correspondent exclusivement au matériel. Les frais de main-d'œuvre liés à l'installation et à la mise en service sont facturés séparément.
            </p>
            <p>
              Main-d'œuvre : 400 € HT / journée · 230 € HT / demi-journée. Frais de déplacement calculés au départ de Lyon, offerts jusqu'à 20 km et pour toute journée réservée (dans la limite de 100 km).
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
